import * as React from "react"

function LogoWhite(props) {
  return (
<svg id="Layer_1" className="w-8 mx-auto" data-name="Layer 1" viewBox="0 0 534.11 534.11">
<polygon className=" fill-white white" points="267.06 0 145.53 121.53 0 267.06 121.53 388.58 202 308.11 202 469.06 267.06 534.12 339.82 461.35 339.82 308.11 412.59 388.58 534.12 267.06 267.06 0"/></svg>    )
}

export default LogoWhite
  